import React from "react";
import "./BackgroundAnimation.css"; // External CSS file

const BackgroundAnimation = () => {
    return (
        <div id="background-container">
          <div className="stars"></div>
          <div className="twinkling"></div>
        </div>
      );
};

export default BackgroundAnimation;
